// import GoogleReviews from "../components/about-us/GoogleReviews";

export default function Test() {
  return (
    <>
      <section className="assortment">{/* <GoogleReviews /> */}</section>
    </>
  );
}
